import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { T } from "@/components/T";

const warumData = {
  de: [
    { nr: "01", titel: "Präzise Planung", nutzen: "Keine Überraschungen. Klare Kosten von Anfang an.", text: "Jedes Projekt beginnt mit strukturierter Planung: 3D-Visualisierung, klare Kostenschätzung, vollständige Einreichunterlagen." },
    { nr: "02", titel: "Saubere Koordination", nutzen: "Ein Ansprechpartner. Klare Zuständigkeiten.", text: "Von der Planung bis zur Übergabe koordinieren wir alle Abläufe. Sie müssen sich nicht um Details kümmern – das ist unser Job." },
    { nr: "03", titel: "Vorfertigung im Werk", nutzen: "Kürzere Bauzeit. Höhere Qualität.", text: "Durch Vorfertigung unter kontrollierten Bedingungen minimieren wir Bauzeit und Fehlerquellen." },
    { nr: "04", titel: "Verlässliche Termine", nutzen: "Geplante Termine sind Verbindlichkeiten.", text: "Termintreue entsteht durch gute Planung, klare Prozesse und einen Auftragnehmer, der Verantwortung übernimmt." },
  ],
  it: [
    { nr: "01", titel: "Pianificazione precisa", nutzen: "Nessuna sorpresa. Costi chiari dall'inizio.", text: "Ogni progetto inizia con una pianificazione strutturata: visualizzazione 3D, stima dei costi chiara, documentazione di presentazione completa." },
    { nr: "02", titel: "Coordinamento efficiente", nutzen: "Un interlocutore. Responsabilità chiare.", text: "Dalla pianificazione alla consegna coordiniamo tutti i processi. Non dovete preoccuparvi dei dettagli – è il nostro lavoro." },
    { nr: "03", titel: "Prefabbricazione in officina", nutzen: "Tempi di costruzione più brevi. Qualità superiore.", text: "Grazie alla prefabbricazione in condizioni controllate, minimizziamo i tempi di costruzione e le fonti di errori." },
    { nr: "04", titel: "Scadenze rispettate", nutzen: "Le date pianificate sono impegni vincolanti.", text: "Il rispetto delle scadenze deriva da buona pianificazione, processi chiari e un appaltatore che si assume le responsabilità." },
  ],
};

export function WarumSection() {
  const { lang } = useLanguage();
  const warum = warumData[lang];
  return (
    <section className="section-gap bg-white relative overflow-hidden" data-testid="warum-section">
      <div className="absolute bottom-0 left-0 pointer-events-none select-none overflow-hidden">
        <span className="font-cormorant font-light text-hb-dark/[0.035] leading-none whitespace-nowrap block"
          style={{ fontSize: "clamp(100px, 17vw, 220px)" }}>
          <T de="SYSTEM" it="SISTEMA" />
        </span>
      </div>
      <div className="container-hb relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-4 lg:sticky lg:top-28">
            <span className="label-text block mb-5 reveal">
              <T de="Warum Holzbuddy" it="Perché Holzbuddy" />
            </span>
            <h2 className="font-bebas text-hb-dark mb-5 reveal reveal-delay-1"
              style={{ fontSize: "clamp(44px, 5.5vw, 72px)", lineHeight: 1.0 }}>
              <T de={<>Holzbau mit System.<br />Nicht mit Zufall.</>}
                 it={<>Costruzione in legno<br />con sistema.</>} />
            </h2>
            <p className="text-sm text-hb-text font-inter leading-relaxed mb-8 reveal reveal-delay-2">
              <T de="Holzbuddy ist die Holzbaumarke der Hafner EC GmbH – einem der erfahrensten Bauunternehmen Südtirols."
                 it="Holzbuddy è il marchio per le costruzioni in legno di Hafner EC GmbH – una delle più esperte aziende edili dell'Alto Adige." />
            </p>
            <Link to="/ueber-uns" data-testid="warum-link" className="btn-link reveal reveal-delay-3">
              <T de="Mehr über das Holzbuddy Team" it="Scopri il team Holzbuddy" />
            </Link>
          </div>
          <div className="lg:col-span-8 border-t border-hb-border">
            {warum.map((w, i) => (
              <div key={w.nr} data-testid={`warum-card-${w.nr}`}
                className={`group flex gap-5 py-8 border-b border-hb-border last:border-b-0 reveal reveal-delay-${(i % 2) + 1}`}>
                <span className="font-cormorant font-light leading-none flex-shrink-0 group-hover:text-hb-yellow transition-colors duration-300"
                  style={{ fontSize: "clamp(48px, 6vw, 72px)", lineHeight: 1, color: "rgba(245,200,0,0.22)" }}>
                  {w.nr}
                </span>
                <div className="pt-1">
                  <h3 className="text-base font-manrope font-bold text-hb-dark mb-1">{w.titel}</h3>
                  <p className="text-xs font-semibold text-hb-yellow mb-2 font-inter">{w.nutzen}</p>
                  <p className="text-sm text-hb-text font-inter leading-relaxed">{w.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
